(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.custom-product-gallery__carousel');
    const modal = document.getElementById('zoomModal');
    const img = document.getElementById('zoomMainImg');
    const counter = document.getElementById('zoomCounter');
    const closeBtn = modal ? modal.querySelector('.zoom-close') : null;
    const prevBtn = document.getElementById('zoomPrevBtn');
    const nextBtn = document.getElementById('zoomNextBtn');
    if (!gallery || !modal || !img) return;

    const MIN = 1, MAX = 4, CLICK_SCALE = 2.5;
    let images = [], index = 0;
    let scale = 1, tx = 0, ty = 0;
    let pointers = new Map();
    let dragStart = null, pinchStart = null, moved = false;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      img.classList.toggle('is-zoomed', scale > 1.01);
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }
    function clamp() {
      const s = modal.getBoundingClientRect();
      const maxX = Math.max(0, (img.offsetWidth * scale - s.width) / 2);
      const maxY = Math.max(0, (img.offsetHeight * scale - s.height) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }
    function zoomAt(newScale, cx, cy) {
      newScale = Math.min(MAX, Math.max(MIN, newScale));
      if (newScale === 1) { reset(); return; }
      const s = modal.getBoundingClientRect();
      const ox = cx - (s.left + s.width / 2 + tx);
      const oy = cy - (s.top + s.height / 2 + ty);
      const k = newScale / scale;
      tx = tx - ox * (k - 1);
      ty = ty - oy * (k - 1);
      scale = newScale;
      clamp();
      apply();
    }
    function srcOf(el) { return el.dataset.zoom || el.currentSrc || el.src; }
    function show(i, animate) {
      if (!images.length) return;
      index = (i + images.length) % images.length;
      const next = srcOf(images[index]);
      if (counter) counter.textContent = (index + 1) + ' / ' + images.length;
      if (animate) {
        img.classList.add('is-switching');
        const pre = new Image();
        pre.onload = pre.onerror = () => { img.src = next; reset(); requestAnimationFrame(() => img.classList.remove('is-switching')); };
        pre.src = next;
      } else { img.src = next; reset(); }
    }
    function open(i) {
      images = [...gallery.querySelectorAll('img.product-gallery__image')];
      modal.classList.toggle('is-single', images.length < 2);
      show(i, false);
      modal.classList.add('is-open');
      document.body.classList.add('zoom-lb-open');
      requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add('is-visible')));
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      modal.classList.remove('is-visible');
      document.body.classList.remove('zoom-lb-open');
      setTimeout(() => { modal.classList.remove('is-open'); reset(); }, 260);
    }
    function isOpen() { return modal.classList.contains('is-open'); }

    gallery.addEventListener('click', (e) => {
      const target = e.target.closest('img.product-gallery__image');
      if (!target) return;
      const all = [...gallery.querySelectorAll('img.product-gallery__image')];
      open(all.indexOf(target));
    });

    if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); close(); });
    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); show(index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); show(index + 1, true); });
    modal.addEventListener('click', (e) => { if (e.target === modal || e.target.classList.contains('zoom-lb__stage')) close(); });

    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1, true); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomAt(scale * 1.5, window.innerWidth / 2, window.innerHeight / 2); }
      else if (e.key === '-') { e.preventDefault(); zoomAt(scale / 1.5, window.innerWidth / 2, window.innerHeight / 2); }
    });

    img.addEventListener('wheel', (e) => {
      e.preventDefault();
      const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
      zoomAt(scale * factor, e.clientX, e.clientY);
    }, { passive: false });

    img.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      img.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      moved = false;
      if (pointers.size === 1) {
        dragStart = { x: e.clientX - tx, y: e.clientY - ty, sx: e.clientX, sy: e.clientY, t: Date.now() };
        if (scale > 1) img.classList.add('is-dragging');
      } else if (pointers.size === 2) {
        const p = [...pointers.values()];
        pinchStart = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), s: scale };
        dragStart = null;
        img.classList.add('is-dragging');
      }
    });
    img.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2 && pinchStart) {
        const p = [...pointers.values()];
        const d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        const cx = (p[0].x + p[1].x) / 2, cy = (p[0].y + p[1].y) / 2;
        zoomAt(pinchStart.s * (d / pinchStart.d), cx, cy);
        moved = true;
      } else if (dragStart && scale > 1) {
        tx = e.clientX - dragStart.x; ty = e.clientY - dragStart.y;
        if (Math.abs(e.clientX - dragStart.sx) > 4 || Math.abs(e.clientY - dragStart.sy) > 4) moved = true;
        clamp(); apply();
      } else if (dragStart) {
        if (Math.abs(e.clientX - dragStart.sx) > 8) moved = true;
      }
    });
    function pointerEnd(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      img.classList.remove('is-dragging');
      if (pointers.size > 0) { pinchStart = null; dragStart = null; return; }
      if (pinchStart) { pinchStart = null; if (scale < 1.05) reset(); return; }
      if (!dragStart) return;
      const dx = e.clientX - dragStart.sx, dy = e.clientY - dragStart.sy, dt = Date.now() - dragStart.t;
      dragStart = null;
      if (scale === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && dt < 600) {
        show(dx < 0 ? index + 1 : index - 1, true);
        return;
      }
      if (!moved) {
        if (scale > 1) reset(); else zoomAt(CLICK_SCALE, e.clientX, e.clientY);
      }
    }
    img.addEventListener('pointerup', pointerEnd);
    img.addEventListener('pointercancel', pointerEnd);
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });
  } catch(e) { console.error(e); }
})();

})();
